/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentExport } from '../../models/document-export';

export interface ExportDocumentsGetPendingDocuments$Params {
  PatientID?: string | null;
  PracticeId?: string | null;
}

export function exportDocumentsGetPendingDocuments(http: HttpClient, rootUrl: string, params?: ExportDocumentsGetPendingDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentExport>>> {
  const rb = new RequestBuilder(rootUrl, exportDocumentsGetPendingDocuments.PATH, 'get');
  if (params) {
    rb.query('PatientID', params.PatientID, {});
    rb.query('PracticeId', params.PracticeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentExport>>;
    })
  );
}

exportDocumentsGetPendingDocuments.PATH = '/exportdocument/getPendingDocuments';
